export enum PaymentErrorType {
	BOLETO_JA_BAIXADO = 'BOLETO_JA_BAIXADO',
	CLIENTE_BENEFICIARIO_INAPTO = 'CLIENTE_BENEFICIARIO_INAPTO',
	BOLETO_NAO_ENCONTRADO = 'BOLETO_NAO_ENCONTRADO',
	ERRO_NAO_MAPEADO = 'ERRO_NAO_MAPEADO'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-securities/models/payment-error-type.ts